
import LoginPage from "@/pages/LoginPage.vue";
import Thongkebenhnhan from "@/pages/Thongkebenhnhan.vue";
import Thongkedoanhthu from "@/pages/Thongkedoanhthu.vue";

import { useStore } from 'vuex'
import { computed } from 'vue'
import { useToast } from "primevue/usetoast";
import {useRouter} from "vue-router";


export default {
  components: {
    LoginPage,
    Thongkebenhnhan,
    Thongkedoanhthu,
   // DanhSachDeTai,
  },
  setup(){
    const store = useStore();
    const isLoggedIn = computed(() => !!store.state.token);
    const permission = computed(() => store.state.permission);
    const toast = useToast();
    console.log("##########$$$$$$$$$$$$$$$ log 11111111");
    console.log("##########$$$$$$$$$$$$$$$ log isLoggedIn: " + isLoggedIn.value);
    console.log("##########$$$$$$$$$$$$$$$ log permission: " + permission.value);

    return {
      isLoggedIn,
      permission,
    }
  }
}
